// extracted by mini-css-extract-plugin
export default {"notFound":"NotFoundPage_notFound__ijMYN","content":"NotFoundPage_content__9rMOD","homeButton":"NotFoundPage_homeButton__qfIN0"};